import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../css/ReferServiceCompany.css';
import ThankYouPopup from "../components/ThankYouPopup";

function ReferServiceCompany() {
    const navigate = useNavigate();
    const [showThankYouPopup, setShowThankYouPopup] = useState(false);
    const [formCompleted, setFormCompleted] = useState(false);
    const [serviceCompanyName, setServiceCompanyName] = useState('');
    const [serviceCompanyContactName, setServiceCompanyContactName] = useState('');
    const [serviceCompanyEmail, setServiceCompanyEmail] = useState('');
    const [serviceCompanyPhoneNumber, setServiceCompanyPhoneNumber] = useState('');
    const [name, setName] = useState('');
    const [dreNumber, setDreNumber] = useState('');
    const [email, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const validateEmail = (serviceCompanyEmail) => {
        const serviceCompanyEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return serviceCompanyEmailRegex.test(serviceCompanyEmail);
    };

    const handleSubmit = async () => {
        if (!(serviceCompanyName && serviceCompanyPhoneNumber && name && dreNumber && email)) {
            setErrorMessage("Please enter all required fields.");
        } else if ((serviceCompanyEmail && !validateEmail(serviceCompanyEmail)) || !validateEmail(email)) {
            setErrorMessage("Please enter a valid email address.");
        } else {
            setErrorMessage("");
            try {
                const data = {
                    serviceCompanyName,
                    serviceCompanyContactName,
                    serviceCompanyEmail,
                    serviceCompanyPhoneNumber,
                    name,
                    dreNumber,
                    email
                };
                await axios.post('/api/refer_service_provider', data)

                setShowThankYouPopup(true);
                setTimeout(function () {
                    navigate("/")
                }, 2000);
            } catch (error) {
                setErrorMessage("There was an error submitting the form. Please try again.");
            }
        }
    };

    const checkFormCompletion = () => {
        if (serviceCompanyName && serviceCompanyPhoneNumber && name && dreNumber && email) {
            setFormCompleted(true);
        } else {
            setFormCompleted(false);
        }
    };

    const handleServiceCompanyNameChange = (e) => {
        setServiceCompanyName(e.target.value);
        checkFormCompletion();
    };

    const handleServiceCompanyContactNameChange = (e) => {
        setServiceCompanyContactName(e.target.value);
        checkFormCompletion();
    };

    const handleServiceCompanyEmailChange = (e) => {
        setServiceCompanyEmail(e.target.value);
        checkFormCompletion();
    };

    const handleServiceCompanyPhoneNumberChange = (e) => {
        setServiceCompanyPhoneNumber(e.target.value);
        checkFormCompletion();
    };

    const handleNameChange = (e) => {
        setName(e.target.value);
        checkFormCompletion();
    };

    const handleDreNumberChange = (e) => {
        setDreNumber(e.target.value);
        checkFormCompletion();
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        checkFormCompletion();
    };

    return (
        <div className="referServiceCompanyContainer">
            <div className="referServiceCompanyWrap">
                <div className="referServiceCompanyTitle">Refer Your Favorite Service Company</div>
                <div className="referServiceCompanyFormWrap">
                    <div className="referServiceCompanyFormRow">
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Service Company Name <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="Company name"
                                value={serviceCompanyName}
                                onChange={handleServiceCompanyNameChange}
                            />
                        </div>
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Service Company Contact Name
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="First / Last name"
                                value={serviceCompanyContactName}
                                onChange={handleServiceCompanyContactNameChange}
                            />
                        </div>
                    </div>
                    <div className="referServiceCompanyFormRow">
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Service Company Email
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="email@company.com"
                                value={serviceCompanyEmail}
                                onChange={handleServiceCompanyEmailChange}
                            />
                        </div>
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Service Company Phone Number <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="000-000-0000"
                                value={serviceCompanyPhoneNumber}
                                onChange={handleServiceCompanyPhoneNumberChange}
                            />
                        </div>
                    </div>
                    <div className="referServiceCompanyFormRow">
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Your Name <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="First / Last name"
                                value={name}
                                onChange={handleNameChange}
                            />
                        </div>
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Department of Real Estate (DRE Number) <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="Enter your DRE number"
                                value={dreNumber}
                                onChange={handleDreNumberChange}
                            />
                        </div>
                    </div>
                    <div className="referServiceCompanyFormRow">
                        <div className="referServiceCompanyFormFieldWrap">
                            <div className="referServiceCompanyFormFieldLabel">
                                Your Email <span className="red">*</span>
                            </div>
                            <input
                                type="text"
                                className="referServiceCompanyFormFieldInput"
                                placeholder="email@company.com"
                                value={email}
                                onChange={handleEmailChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="referServiceCompanyFormRequiredInfo">
                    <span className="red">*</span> Required
                </div>
                {errorMessage &&
                    <div className="referServiceCompanyFormSubmitErrorMessage">{errorMessage}</div>}
                <div className="referServiceCompanyFormSubmitButtonWrap">
                    <div
                        className={`referServiceCompanyFormSubmitButton ${formCompleted ? 'action' : ''}`}
                        onClick={handleSubmit}
                    >
                        Submit
                    </div>
                </div>
            </div>
            {showThankYouPopup ? <ThankYouPopup message="Thanks for referring your favorite service company. We will reach other to them and mention you've referred them to us."/> : null}
        </div>
    );
}

export default ReferServiceCompany;
